import DOMPurify from 'dompurify';
import { v4 as uuidv4 } from 'uuid';
/*
  Basic validations
*/
export const isStringEmpty = (str) => !str || `${str}`.trim().length === 0;
export const isSafeString = (value) => {
    return typeof value === 'string' || typeof value === 'number';
};
/*
  Capitalization
*/
export const titleCase = (str) => {
    const split = str.split(' ');
    return split.map((word) => capitalizeFirstLetter(word)).join(' ');
};
export const capitalizeFirstLetter = (str) => str.charAt(0).toUpperCase() + str.slice(1);
/*
  Misc
*/
export const getHumanReadableList = (translatedItems, translatedAnd) => {
    let humanReadableList = '';
    if (translatedItems.length > 1) {
        humanReadableList = `${translatedItems
            .slice(0, -1)
            .join(', ')} ${translatedAnd} ${translatedItems[translatedItems.length - 1]}`;
    }
    else if (translatedItems.length > 0) {
        humanReadableList = translatedItems[0];
    }
    return humanReadableList;
};
export const letterFromIndex = (i) => i > 25
    ? String.fromCharCode((i % 26) + 65).toLowerCase()
    : String.fromCharCode(i + 65);
export const createRandomFileKey = (ext) => {
    const randomString = uuidv4();
    return `${randomString}.${ext}`;
};
/*
  HTML parsing
*/
const parseHTML = (str) => {
    const doc = new DOMParser().parseFromString(str, 'text/html');
    return Array.from(doc.body.childNodes);
};
const isHTML = (nodes) => {
    return nodes.some((node) => node.nodeType === Node.ELEMENT_NODE);
};
export const safeString = (str) => {
    if (typeof str === 'number')
        return str.toLocaleString();
    const htmlNodes = parseHTML(str);
    if (isHTML(htmlNodes)) {
        const textContents = htmlNodes
            .map((node) => node.textContent)
            .filter((text) => `${text}`.trim().length > 0);
        if (textContents.length > 0) {
            return textContents.join('<br/><br/>');
        }
        return '';
    }
    return str;
};
/*
  URLs
*/
export const isUrl = (str) => {
    const urlRegex = new RegExp('^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$', 'i');
    return !!urlRegex.test(str);
};
export const urlLink = (url, linkText) => {
    if (!url.startsWith('http')) {
        url = 'http://' + url;
    }
    return `<a href="${url}" target="_blank" class="underline">${linkText}</a>`;
};
/*
  Mapbox feature properties parsing
*/
export const propertyName = (key) => key.replaceAll(/[-_]/g, ' ');
/*
  File name display
*/
export const getTruncatedFileName = (fileName, maxLength = 12) => {
    if (fileName.length <= maxLength)
        return fileName;
    const extension = fileName.includes('.')
        ? fileName.split('.').pop() || ''
        : '';
    const nameWithoutExt = fileName.slice(0, -(extension.length + 1));
    if (extension.length >= maxLength) {
        return `${fileName.slice(0, maxLength - 3)}...`;
    }
    return `${nameWithoutExt.slice(0, maxLength - extension.length - 3)}...${extension}`;
};
/*
  Character limit checks
*/
export const isLongerThanCharacterLimit = (input, limit = 40, urlDisplayLabel = 'Visit Website') => {
    if (!input)
        return false;
    // Check cleaned length if <br> tags are present
    if (input.includes('<')) {
        const stripped = DOMPurify.sanitize(input, {
            ALLOWED_TAGS: [],
            ALLOWED_ATTR: []
        });
        return stripped.length > limit;
    }
    // For URLs, check display text length
    if (isUrl(input)) {
        return urlDisplayLabel.length > limit;
    }
    // Default: check raw string length
    return input.length > limit;
};
//# sourceMappingURL=strings.js.map